import { PropsWithChildren } from 'react'
import { BrandSection } from '@wellesley/auth'

export const BrandLayout = ({ children }: PropsWithChildren) => (
  <div className="flex h-[100vh] w-full items-stretch">
    <BrandSection className="min-w-[492px]" />
    <div className="flex w-full items-center justify-center bg-gray-100">
      {children}
    </div>
  </div>
)
